import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVolumeXmark as faSolidVolumeXmark } from "@fortawesome/pro-solid-svg-icons";
import { faVolumeXmark as faRegularVolumeXmark } from "@fortawesome/pro-regular-svg-icons";

export default function Muted() {
  return (
    <span className="stack-item fa-layers self-end leading-none">
      <FontAwesomeIcon className="text-white" icon={faSolidVolumeXmark} />
      <FontAwesomeIcon className="text-danger" icon={faRegularVolumeXmark} />
    </span>
  );
}
